import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { NSGridActionCellModule, NSGridModule } from '@norfolk-southern/accessns-components';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';

import { SlCustomersComponent } from '@ruby/modules/short-line-profile/submodules/sl-customers/components/sl-customers.component';
import { SlActionsContainer } from '@ruby/modules/short-line-profile/submodules/sl-customers/containers/sl-actions/sl-actions.container';
import { SlCustomersContainer } from '@ruby/modules/short-line-profile/submodules/sl-customers/containers/sl-customers.container';
import { SlCustomersRoutingModule } from '@ruby/modules/short-line-profile/submodules/sl-customers/sl-customers-routing.module';
import { ShortLineModule } from '@ruby/shared/dialogs/short-line/short-line.module';

@NgModule({
  declarations: [
    SlCustomersComponent,
    SlCustomersContainer,
    SlActionsContainer
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    NSGridActionCellModule,
    NSGridModule,
    SlCustomersRoutingModule,
    ShortLineModule,
    SweetAlert2Module
  ]
})
export class SlCustomersModule {}
